import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { Store } from '../redux/typings/store';

export const RequiresPasswordReset: React.FC = () => {
  const user = useSelector((store: Store) => store.session.user);
  if (user && user.requestPasswordReset) {
    return <Outlet />;
  } else {
    return <Navigate to={'/'} />;
  }
};
